import { service } from '@ember/service'
import type SideNavService from 'teacher-ui-client/services/side-nav'
import { SideNavAccordionList, SideNavAccordionItem } from 'teacher-ui-client/components/side-nav/accordion'
import Component from '@glimmer/component'
import { t } from 'ember-intl'
import { hash } from '@ember/helper'
import canAccess from 'teacher-ui-client/helpers/can-access'
import mortarboardUnfilled from '@images/icons/mortarboard-unfilled.svg'

export class MathsTeacherToolkitAccordion extends Component {
  @service sideNav!: SideNavService

  get isVisible() {
    return this.sideNav.showTeacherToolkit
  }

  <template>
    {{#if this.isVisible}}
      <SideNavAccordionList
        @iconUrl={{mortarboardUnfilled}}
        @iconAlt="Sidenav cap"
        @label={{t "sideNav.reading.teacherToolkit"}}
      >
        <SideNavAccordionItem @route="subscription-type.teacher-toolkit" @query={{hash category="/maths/lower"}}>
          {{t "sideNav.maths.k2TeacherResources"}}
        </SideNavAccordionItem>
        <SideNavAccordionItem @route="subscription-type.teacher-toolkit" @query={{hash category="/maths/middle"}}>
          {{t "sideNav.maths.34TeachingResources"}}
        </SideNavAccordionItem>
        {{#if (canAccess "msp_product")}}
          <SideNavAccordionItem @route="subscription-type.teacher-toolkit" @query={{hash category="/maths/prime"}}>
            {{t "sideNav.maths.primeResources"}}
          </SideNavAccordionItem>
        {{/if}}
        <SideNavAccordionItem @route="subscription-type.teacher-toolkit" @query={{hash category="/maths/assessments"}}>
          {{t "sideNav.maths.assessments"}}
        </SideNavAccordionItem>

        <SideNavAccordionItem @route="subscription-type.big-books">
          {{t "sideNav.maths.bigBooks"}}
        </SideNavAccordionItem>

        <SideNavAccordionItem @route="teacher-resources.curriculum-maps">
          {{t "sideNav.maths.curriculumMap"}}
        </SideNavAccordionItem>
      </SideNavAccordionList>
    {{/if}}
  </template>
}
